<template>

  <section id="hp-top" class='fixed-top' :class="{ ddd }">
    <div v-if="graphic">
      <a href="/dozywotnia-gwarancja">
        <div id="bnp-slide" class="hp-header">

          <div class="row" v-if="is_pl">

            <div class="col-left">
              <div class="raty"></div>
            </div>
            <div class="col-right">
              <div class="info">
                <p class="first">Nowość! </p>
                <p class="second">Dożywotnia <br/><span>Gwarancja</span></p>
                <p class="three">Na Ramy <strong>Le Grand</strong> We wszystkich punktach sprzedaży i online!</p>
                <a href="/dozywotnia-gwarancja" class="btn white">SPRAWDŻ!</a>
              </div>


            </div>
          </div><!-- // row -->
        </div>
      </a>
    </div>

    <div v-if="!graphic">
      <div v-if="!startMovie" class="container">
        <div class="site content home">

          <div class="row">

            <div class="col-left">
              <div class="series-classic">
                <serie-logo serie="classic"></serie-logo>
              </div>
            </div>

            <div class="col-center">
              <div class="horizontal">
                <div class="divider color-mint-bg"></div>
                <div class="arrow-down mint"></div>
                <div class="arrow-down mint"></div>
              </div>
            </div>
            <div class="col-right">
              <h1 v-translate="'top_h1'">KLASYCZNIE<br/>I ERGONOMICZNIE</h1>
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <video id="videoHeader" v-on:click="toggleVideo" playsinline autoplay loop muted>
          <source src="/video/video.mp4" type="video/mp4">
          <source src="/video/video.ogg" type="video/ogg">
          <source src="/video/video.webm" type="video/webm">
        </video>
      </div>
    </div><!-- movie -->

  </section>

</template>
<script>

  import SerieLogo from '../Graphics/SerieLogo.vue'

  export default {
    name: 'HomePageTop',
    data() {
      return {
        ddd: false,
        graphic: true,
        startMovie: true,
        moviePausePernament: false,
        is_pl: env.language === 'pl'
      }
    },
    components: {
      SerieLogo
    },
    created: function () {
      window.addEventListener('scroll', this.scrollVideo);
      window.addEventListener('resize', this.scrollVideo);
      // czy mamy daty akcji dzień darmowej dostawy
      if (typeof window.ddd !== "undefined") {
        let now = new Date();
        this.ddd = (now > window.ddd.start && now < window.ddd.end );
      }
    },

    destroyed: function () {
      window.addEventListener('scroll', this.scrollVideo);
      window.addEventListener('resize', this.scrollVideo);
    },

    methods: {
      scrollVideo: function () {
        let vid = document.getElementById("videoHeader");
        if(vid == null) return;
        let scroll = $(window).scrollTop();
        let heightElements = (document.getElementById("page-top").clientHeight + document.getElementById("city").clientHeight) * 1.5;

        if (scroll > vid.clientHeight - heightElements) {
          vid.pause();
        } else if (scroll <= vid.clientHeight - heightElements && this.moviePausePernament == false) {
          vid.play();
        }
      },
      toggleVideo: function () {
        let vid = document.getElementById("videoHeader");
        if(vid == null) return;
        if (vid.paused) {
          vid.play();
          this.moviePausePernament = false;
        } else {
          vid.pause();
          this.moviePausePernament = true;

        }
      }
    },


  }
</script>
<style scoped>
  #hp-top .row .arrow-down {
    width: .7vw;
    height: .7vw;
  }

  #hp-top .row .divider {
    width: 0.104166667vw;
    height: 12.5vw;
  }

  video {
    width: 100%;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/HomePage/Top.vue